import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import { toFormData } from "helpers/formUtils";
import categoriesService from "services/admin/categoriesService";

interface TicketCategoryFormProps {
  router: any;
  data: any;
}

const TicketCategoryForm = ({ router, data }: TicketCategoryFormProps) => {
  const { navigate, params: { id } } = router;
  const { category } = data;

  const fieldsWithData = [
    {
      key: "name",
      label: "Название категории",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "description",
      label: "Описание категории",
      required: true,
      inputType: inputTypeEnum.richText,
    },
  ]

  const onSubmit = async (formValues: any) => {
    try {
      formValues.type = 'TICKET';
      if (category) {
        await categoriesService.put(id, formValues)
        snack("Категория обновлен успешно!");
      } else {
        await categoriesService.post(formValues)
        snack("Категория создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={category ? 'Редактирование категории' : 'Создание категории'}>
      <AppForm onSubmit={onSubmit} data={category} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(TicketCategoryForm, (router: any) => {
    let requests: any = {}
    if (router.params.id) {
      requests['category'] = () => categoriesService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
